<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g id="LinkedIn">
      <g id="Icon-7" data-name="Icon">
        <path d="M18.437,3.063H5.564a2.5,2.5,0,0,0-2.5,2.5V18.437a2.5,2.5,0,0,0,2.5,2.5H18.437a2.5,2.5,0,0,0,2.5-2.5V5.563A2.5,2.5,0,0,0,18.437,3.063Zm1.5,15.374a1.5,1.5,0,0,1-1.5,1.5H5.564a1.5,1.5,0,0,1-1.5-1.5V5.563a1.5,1.5,0,0,1,1.5-1.5H18.437a1.5,1.5,0,0,1,1.5,1.5Z" />
        <path d="M7.376,9.748a1.017,1.017,0,0,0-1,1v6.5a1,1,0,0,0,2,0v-6.5A1.011,1.011,0,0,0,7.376,9.748Z" />
        <circle cx="7.376" cy="6.744" r="1" />
        <path d="M14.006,9.748a3.573,3.573,0,0,0-1.784.49.953.953,0,0,0-.833-.49,1.017,1.017,0,0,0-1,1v6.5a1,1,0,0,0,2,0v-3.88a1.618,1.618,0,1,1,3.235,0v3.88a1,1,0,0,0,2,0v-3.88A3.622,3.622,0,0,0,14.006,9.748Z" />
      </g>
    </g>
  </svg>
</template>
